<script lang="ts" setup>
import { ref, Ref } from 'vue'
import { useDialogPluginComponent, Notify } from 'quasar'
import { GeneratedDocument } from '@/models/files/GeneratedDocument'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import BaseDialog from '@/components/base/BaseDialog.vue'

interface Props {
  selectedFile: GeneratedDocument
}
const props = defineProps<Props>()

const userApi: UserApi = useApi()
const isLoading: Ref<boolean> = ref(false)

const emit = defineEmits([...useDialogPluginComponent.emits])
const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

async function deleteFile() {
  if (props.selectedFile) {
    try {
      isLoading.value = true
      await userApi.deleteTaskDocument(props.selectedFile.id)
      isLoading.value = false
      emit('ok')
      Notify.create({
        message: 'Document supprimé',
        type: 'primary',
      })
    } catch (e) {
      dialogRef.value?.hide()
      isLoading.value = false
      Notify.create({
        message: 'Une erreur est survenue lors de la suppression du document',
        type: 'negative',
      })
    }
  }
}
</script>

<template>
  <q-dialog ref="dialogRef">
    <BaseDialog
      title="Supprimer le document"
      :is-dialog-loading="isLoading"
      @on-dialog-cancel="onDialogCancel()"
      @hide="onDialogHide()"
    >
      <template #body> Êtes-vous sûr de vouloir supprimer le document ? </template>
      <template #actions>
        <q-btn flat label="Supprimer" @click="deleteFile()" color="negative" />
      </template>
    </BaseDialog>
  </q-dialog>
</template>
<style lang="scss" scoped></style>
